module.exports = __webpack_public_path__ + "71da95497a1b1f57774aa1110db2c7ff.png";